const AUTHENTICITY_TOKEN_ERROR_MESSAGE = 'Sorry, your request could not be processed as it contained an invalid security token. Please refresh and try again.'

export const XsrfResilient = <T, K>(asyncFunctor: (args?) => Promise<T>) => async (args?: K) => {
  try {
    return await asyncFunctor(args)
  } catch (possibleXsrfResponse) {
    const error = possibleXsrfResponse?.response?.data?.error
    if (error === AUTHENTICITY_TOKEN_ERROR_MESSAGE) {
      return await asyncFunctor(args)
    }
    throw error
  }
}
